/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceReference } from './SourceReference';
import {
    SourceReferenceFromJSON,
    SourceReferenceFromJSONTyped,
    SourceReferenceToJSON,
    SourceReferenceToJSONTyped,
} from './SourceReference';
import type { FrameworkMapping } from './FrameworkMapping';
import {
    FrameworkMappingFromJSON,
    FrameworkMappingFromJSONTyped,
    FrameworkMappingToJSON,
    FrameworkMappingToJSONTyped,
} from './FrameworkMapping';
import type { FieldProvenance } from './FieldProvenance';
import {
    FieldProvenanceFromJSON,
    FieldProvenanceFromJSONTyped,
    FieldProvenanceToJSON,
    FieldProvenanceToJSONTyped,
} from './FieldProvenance';

/**
 * 
 * @export
 * @interface WeaknessDefinitionEntity
 */
export interface WeaknessDefinitionEntity {
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    weaknessType?: WeaknessDefinitionEntityWeaknessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    framework?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    frameworkId?: string;
    /**
     * 
     * @type {Array<FrameworkMapping>}
     * @memberof WeaknessDefinitionEntity
     */
    frameworkMappings?: Array<FrameworkMapping>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    severity?: WeaknessDefinitionEntitySeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof WeaknessDefinitionEntity
     */
    riskScore?: number;
    /**
     * 
     * @type {number}
     * @memberof WeaknessDefinitionEntity
     */
    cvssScore?: number;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    cvssVector?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    controlId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessDefinitionEntity
     */
    controlIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    remediation?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    workaround?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessDefinitionEntity
     */
    references?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessDefinitionEntity
     */
    affectedProducts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionEntity
     */
    exploitAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionEntity
     */
    patchAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {Array<SourceReference>}
     * @memberof WeaknessDefinitionEntity
     */
    sourceReferences?: Array<SourceReference>;
    /**
     * 
     * @type {{ [key: string]: FieldProvenance; }}
     * @memberof WeaknessDefinitionEntity
     */
    fieldProvenance?: { [key: string]: FieldProvenance; };
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionEntity
     */
    lastSyncedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const WeaknessDefinitionEntityWeaknessTypeEnum = {
    Vulnerability: 'VULNERABILITY',
    ConfigurationFinding: 'CONFIGURATION_FINDING',
    ComplianceGap: 'COMPLIANCE_GAP',
    PolicyGap: 'POLICY_GAP',
    InsuranceGap: 'INSURANCE_GAP',
    ProcedureGap: 'PROCEDURE_GAP',
    RedTeamFinding: 'RED_TEAM_FINDING',
    SecurityAssessment: 'SECURITY_ASSESSMENT',
    PenetrationTest: 'PENETRATION_TEST',
    NetworkMisconfiguration: 'NETWORK_MISCONFIGURATION',
    AccessControlIssue: 'ACCESS_CONTROL_ISSUE',
    IdentityMisconfiguration: 'IDENTITY_MISCONFIGURATION',
    ApplicationSecurity: 'APPLICATION_SECURITY',
    ApiSecurity: 'API_SECURITY',
    CspmFinding: 'CSPM_FINDING',
    CloudMisconfiguration: 'CLOUD_MISCONFIGURATION',
    Custom: 'CUSTOM',
    Other: 'OTHER'
} as const;
export type WeaknessDefinitionEntityWeaknessTypeEnum = typeof WeaknessDefinitionEntityWeaknessTypeEnum[keyof typeof WeaknessDefinitionEntityWeaknessTypeEnum];

/**
 * @export
 */
export const WeaknessDefinitionEntitySeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type WeaknessDefinitionEntitySeverityEnum = typeof WeaknessDefinitionEntitySeverityEnum[keyof typeof WeaknessDefinitionEntitySeverityEnum];


/**
 * Check if a given object implements the WeaknessDefinitionEntity interface.
 */
export function instanceOfWeaknessDefinitionEntity(value: object): value is WeaknessDefinitionEntity {
    return true;
}

export function WeaknessDefinitionEntityFromJSON(json: any): WeaknessDefinitionEntity {
    return WeaknessDefinitionEntityFromJSONTyped(json, false);
}

export function WeaknessDefinitionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessDefinitionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'weaknessType': json['weaknessType'] == null ? undefined : json['weaknessType'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'frameworkId': json['frameworkId'] == null ? undefined : json['frameworkId'],
        'frameworkMappings': json['frameworkMappings'] == null ? undefined : ((json['frameworkMappings'] as Array<any>).map(FrameworkMappingFromJSON)),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'riskScore': json['riskScore'] == null ? undefined : json['riskScore'],
        'cvssScore': json['cvssScore'] == null ? undefined : json['cvssScore'],
        'cvssVector': json['cvssVector'] == null ? undefined : json['cvssVector'],
        'category': json['category'] == null ? undefined : json['category'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlIds': json['controlIds'] == null ? undefined : json['controlIds'],
        'remediation': json['remediation'] == null ? undefined : json['remediation'],
        'workaround': json['workaround'] == null ? undefined : json['workaround'],
        'references': json['references'] == null ? undefined : json['references'],
        'affectedProducts': json['affectedProducts'] == null ? undefined : json['affectedProducts'],
        'exploitAvailable': json['exploitAvailable'] == null ? undefined : json['exploitAvailable'],
        'patchAvailable': json['patchAvailable'] == null ? undefined : json['patchAvailable'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'sourceReferences': json['sourceReferences'] == null ? undefined : ((json['sourceReferences'] as Array<any>).map(SourceReferenceFromJSON)),
        'fieldProvenance': json['fieldProvenance'] == null ? undefined : (mapValues(json['fieldProvenance'], FieldProvenanceFromJSON)),
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function WeaknessDefinitionEntityToJSON(json: any): WeaknessDefinitionEntity {
    return WeaknessDefinitionEntityToJSONTyped(json, false);
}

export function WeaknessDefinitionEntityToJSONTyped(value?: WeaknessDefinitionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'weaknessType': value['weaknessType'],
        'framework': value['framework'],
        'frameworkId': value['frameworkId'],
        'frameworkMappings': value['frameworkMappings'] == null ? undefined : ((value['frameworkMappings'] as Array<any>).map(FrameworkMappingToJSON)),
        'title': value['title'],
        'description': value['description'],
        'severity': value['severity'],
        'riskScore': value['riskScore'],
        'cvssScore': value['cvssScore'],
        'cvssVector': value['cvssVector'],
        'category': value['category'],
        'controlId': value['controlId'],
        'controlIds': value['controlIds'],
        'remediation': value['remediation'],
        'workaround': value['workaround'],
        'references': value['references'],
        'affectedProducts': value['affectedProducts'],
        'exploitAvailable': value['exploitAvailable'],
        'patchAvailable': value['patchAvailable'],
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'sourceReferences': value['sourceReferences'] == null ? undefined : ((value['sourceReferences'] as Array<any>).map(SourceReferenceToJSON)),
        'fieldProvenance': value['fieldProvenance'] == null ? undefined : (mapValues(value['fieldProvenance'], FieldProvenanceToJSON)),
        'lastSyncedAt': value['lastSyncedAt'] == null ? undefined : ((value['lastSyncedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

